const ChatHeader = ({ name, status }) => {
  return (
    <div className="chat-header">
      <strong>{name}</strong>
      <span className={status === "online" ? "online" : "offline"}>
        {status}
      </span>
    </div>
  );
};

export default ChatHeader;